import { Component, Input, OnInit } from '@angular/core'
import { environment } from '@se-po/shared-environments'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

@Component({
  selector: 'se-po-persona-avatar-group',
  templateUrl: './persona-avatar-group.component.html',
  styleUrls: ['./persona-avatar-group.component.scss'],
  standalone: false,
})
export class PersonaAvatarGroupComponent implements OnInit {

  @Input() public profiles: UserProfile[]

  public avatars: any[]

  public ngOnInit(): void {
    this.avatars = this.profiles.slice(0, 5).map((profile) => ({
      id: profile.persona.id,
      imageUrl: this.getImageUrl(profile.persona),
      title: this.getTitle(profile.persona)
    }))
  }

  public goToHousehold(personaId: string) {
    window.location.href = `${environment.mySE}/household?id=${personaId}`
  }

  private getImageUrl(persona: Persona): string {
    const profileImages: any = 'profile_image' in persona ? persona.profile_image : persona.profile_images
    return (profileImages || []).find(i => i.image_type === 'crop')?.url
  }

  private getTitle(persona: Persona): string {
    return 'name' in persona ? persona.name : `${persona?.first_name} ${persona?.last_name}`
  }

}
